(function () {
  var button = document.getElementById('FloatingCartButton');
  if (!button) return;

  // Stays hidden until the visitor has scrolled 15% into the page — showing
  // it immediately on load competed with the hero/header for attention.
  var SHOW_AFTER_SCROLL_RATIO = 0.15;
  var ticking = false;

  function updateVisibility() {
    ticking = false;
    var scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
    var scrollRatio = scrollableHeight > 0 ? window.scrollY / scrollableHeight : 0;
    button.classList.toggle('is-visible', scrollRatio >= SHOW_AFTER_SCROLL_RATIO);
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateVisibility);
  }

  updateVisibility();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  button.addEventListener('click', function () {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open(button);
    } else {
      window.location.href = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + 'cart'
        : '/cart';
    }
  });

  function updateCount() {
    fetch('/cart.js')
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (cart) {
        if (!cart) return;
        var countEl = button.querySelector('[data-floating-cart-count]');
        if (!countEl) return;
        countEl.textContent = cart.item_count;
        countEl.hidden = cart.item_count === 0;
      })
      .catch(function () {
        // Non-critical — the badge just stays at its last known count.
      });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, updateCount);
  }
})();
